module.exports = __webpack_public_path__ + "img/member.0dc680a9.jpg";